import { React, useEffect, useState, useContext, useRef } from 'react'
import { MyContextProvider } from "../../../../App";
import axios, { all } from "axios";
import { API_URL } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { shortMonthToFull, isEndDateGreater, getFormattedDate, changeDateFormat } from '../../../../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import messages from '../../../../assets/Messages.json';
import priceTitle from '../../../../price.json';
import { generateRuralMonthlyIndicesReport } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import ReactEcharts from "echarts-for-react";

function MonthlyIndicesofallRegionandState() {
    const token = useContext(MyContextProvider).token;
    const decode_token = jwtDecode(token);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [reportType, setReportType] = useState('');
    const storedLanguage = localStorage.getItem('language');
    const chartRef = useRef(null);
    const [topFiveItemsObject, settopFiveItemsObject] = useState({});
    const today = new Date();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };



    const handleReportTypeChange = (e) => {
        setReportType(e.target.value)
        setStartDate(null);
        setEndDate(null);

    }


    const formatGrossValue = (value) => {
        if (value === 0) return '0.00';
        if (value === "NaN") return '';
        if (value === '' || value === null || value === 'null') return '0.00';
        return Number(value).toFixed(2);
    };

    //handle excel sheet ***************
    const handleGenerateExcel = async () => {
        if (reportType === '') {
            toast.error('Please select Report Type', messages.COLOR_RED);
            return;
        }
        if (!startDate || !endDate) {
            toast.error('Please select the date range', messages.COLOR_RED);
            return;
        }

        if (!isEndDateGreater(startDate, endDate)) {
            toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
            return;
        }

        // Use different variable names to avoid conflicts
        const formattedStartDate = getFormattedDate(startDate);
        const formattedEndDate = endDate ? getFormattedDate(endDate) : '';
        try {
            showLoading(true);

            // Prepare payload
            const payload = {
                fromDate: formattedStartDate,
                toDate: formattedEndDate,
                report_type: reportType,
            };
            const response = await axios.post(`${API_URL}api/price/RuralMonthlyIndicesofAllRegionandState`, payload, config);
            const reportData = response.data.data;
            const annualIndexData = reportData.finalPriceList;
            const chartPriceList = reportData.chartPriceList;

            if (response.data.status) {
                let year = [];
                let data = []
                const convertToZero = (value) => (value === '0.00' ? 0 : value);
                chartPriceList.forEach((item) => {
                    data.push({
                        indices: [
                            convertToZero(item.index_state),
                            convertToZero(item.index_west),
                            convertToZero(item.index_central),
                            convertToZero(item.index_bundelkhand),
                            convertToZero(item.index_east),
                        ],
                        year: item.year
                    });
                });

                let a = data.map((item, index) => (

                    {
                        name: item.year,
                        type: 'bar',
                        data: item.indices,
                        label: { show: true, position: 'top', formatter: '{c}', color: '#000' },
                    }


                ))

                const generateUniqueColors = (count) => {
                    const colors = new Set();

                    while (colors.size < count) {
                        const hue = Math.floor(Math.random() * 360);
                        const saturation = 70 + Math.floor(Math.random() * 30);
                        const lightness = 40 + Math.floor(Math.random() * 20);

                        colors.add(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
                    }

                    return Array.from(colors);
                };



                let topFiveItemsObjectdata = {
                    "legend": {},
                    grid: {
                        top: 100,
                        left: 50,
                        right: 20,
                        bottom: 40,
                    },
                    color: generateUniqueColors(30),
                    xAxis: {
                        type: 'category',
                        data: ['state', 'West', 'Central', 'Bundelkhand', 'East'],
                        axisLabel: {
                            interval: 0,
                            align: 'center'
                        }
                    },
                    yAxis: {
                        min: 0,
                        max: 250,
                        interval: 25,
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                    series: a


                };
                showLoading(false);

                settopFiveItemsObject(topFiveItemsObjectdata)
                return {
                    annualIndexData: annualIndexData,
                    report: reportType,
                    formattedStartDate: formattedStartDate,
                    formattedEndDate: formattedEndDate,
                }


            } else {

                toast.error('Data is not found', messages.COLOR_RED);
                return;
            }


        } catch (error) {
            console.error(error);

        } finally {
            showLoading(false);
        }
    };


    const handleButtonClick = async () => {
        let data = await handleGenerateExcel();
        setTimeout(() => {
            const image = handleDownload();
            if (image) {
                let parmsdata = data
                parmsdata.chartImage = image
                downloadReport(parmsdata)
            } else {
                console.error('Image URL is null');
            }
        }, 1000);
    };


    const downloadReport = ({ annualIndexData, report, formattedStartDate, formattedEndDate, chartImage }) => {

        const transformedData = annualIndexData.map(item => {
            if (report === "All") {
                return [
                    item.reportYear,
                    item.index_state,
                    item.index_west,
                    item.index_central,
                    item.index_bundelkhand,
                    item.index_east,
                    item.year
                ];
            } else {
                return [
                    item.reportYear,
                    item.index_state,
                    item.major1,
                    item.major2,
                    item.major3,
                    item.major4,
                    item.major5,
                    item.year
                ];
            }
        });
        let headerHindiColumns = [];
        let headerEnglishColumns = []
        if (report === "All") {
            headerHindiColumns = ['', '', 'पश्चिमी', 'मध्य', 'बुंदेलखंड ', 'पूर्वी ', '']
            headerEnglishColumns = ['मास / त्रैमास ', 'State', 'Western', 'Central', 'Bundelkhand', `Eastern`, 'Month/Qt.'
            ]
        } else {
            headerHindiColumns = ['अवधि', 'सामान्य सूचकांक ', 'खाद्य पेय द्रव्य और तम्बाकू ', 'ईधन व प्रकाश',
                'आवास ', 'वस्त्र बिस्तर  एवं जूते ', 'विविध', 'Period']
            headerEnglishColumns = ['मास एवं त्रैमास',
                'General Indices', 'Food , Beverages & Tobacco', 'Fuel & Light',
                'Housing', `Clothing & Footwear`, 'Misc. ', 'Month/Qt (Weight)'
            ]
        }
        const excelObjectData1 = {
            report_type: report === 'All' ? 'RegionWise' : 'MajorGroup',
            sheetName: 'Page1',
            firstRowMergeCells: report === 'All' ? 'A1:G1' : 'A1:H1',
            firstRowExportDate: changeDateFormat(new Date()),
            secondRowMergeCells: report === 'All' ? 'A2:G2' : 'A2:H2',
            secondRowText: `उत्तर प्रदेश का ग्रामीण उपभोक्ता भाव सूचकांक (आधार  कृषि  वर्ष  2011-12=100)`,
            thirdRowMergeCells: report === 'All' ? 'A3:G3' : 'A3:H3',
            thirdRowText: `${report === 'All' ? ' क्षेत्रवार  सामान्य  सूचकांक' : 'प्रमुख वर्गवार सूचकांक'}   `,
            fourthRowMergeCells: report === 'All' ? 'A4:G4' : 'A4:H4',
            fourthRowText: `RURAL CONSUMER PRICE INDEX OF U.P.(Base Agr. Year 2011-12=100)`,
            fifthRowMergeCells: report === 'All' ? 'A5:G5' : 'A5:H5',
            fifthRowText: `${report === 'All' ? 'Region Wise' : 'Major GroupWise'} Indices (${formattedStartDate}-${formattedEndDate})`,
            headerHindiColumns: headerHindiColumns,
            headerEnglishColumns: headerEnglishColumns,
            excelRowData: transformedData
        };



        const excelObjectData2 = {
            sheetName: "Page2",
            firstRowMergeCells: "A1:O1",
            firstRowExportDate: changeDateFormat(new Date()),
            base64String: chartImage,
            secondRowMergeCells: "A2:O2",
            secondRowText: `Variation in index of all Eco - Regions in the State`,

        }

        let finalObject = {
            excelObjectData: [
                excelObjectData1,
                excelObjectData2
            ],
            fileName: `${report === 'All' ? 'RegionWise' : 'MajorGroup'}GeneralIndex_Rural(${formattedStartDate}-${formattedEndDate}).xls`

        }




        generateRuralMonthlyIndicesReport(finalObject);
    }


    const handleDownload = () => {
        if (chartRef.current) {

            const chartInstance = chartRef.current.getEchartsInstance();
            const imageUrl = chartInstance.getDataURL({
                type: 'png',
                pixelRatio: 4,
                backgroundColor: '#fff',
            });
            return imageUrl;
        }
        return null;
    };



    return (
        <>
            <ToastContainer />
            <GlobalLoading />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.MONTHY_INDICATES_OFF_REGION_AND_INDEX_REPORT : priceTitle.en.MONTHY_INDICATES_OFF_REGION_AND_INDEX_REPORT }} />
                            </h4>
                            <div className="row align-items-center">

                                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                                    <label> Select Group</label>

                                    <select
                                        name="report_type"
                                        className="form-select"
                                        onChange={handleReportTypeChange}
                                        value={reportType}
                                    >
                                        <option value="" disabled>[---Select--]</option>
                                        <option value="All">Region Wise</option>
                                        <option value="Major Group">Major Group</option>
                                    </select>

                                </div>


                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">From Date</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        selected={startDate}
                                        onChange={(e) => (setStartDate(e))}
                                        dateFormat="MMM yyyy"
                                        showMonthYearPicker
                                        placeholderText="Select month"
                                        name="startDate"
                                        maxDate={today}
                                    />
                                </div>


                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">To Date</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        selected={endDate}
                                        onChange={(e) => (setEndDate(e))}
                                        dateFormat="MMM yyyy"
                                        showMonthYearPicker
                                        placeholderText="Select month"
                                        name="endDate"
                                        maxDate={today}
                                    />
                                </div>


                                <div className="col-xl-2 col-lg-4 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleButtonClick} className="btn btn_orange">Get Report</button>
                                </div>
                                <div style={{ position: 'absolute', left: '-9999px' }}>
                                    {<ReactEcharts ref={chartRef} option={topFiveItemsObject} style={{ height: '400px', width: '100%' }} />}
                                </div>

                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MonthlyIndicesofallRegionandState